import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function AdminLoginPage() {
  const { user, ready, login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);

  if (ready && user && user.role === "admin") return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const data = await login(form.email, form.password);
      if (data.role !== "admin") {
        toast.error("Not an admin account");
        return;
      }
      nav("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="container-x py-24" data-testid="admin-login-page">
      <div className="max-w-md mx-auto card-soft p-10">
        <div className="font-script text-2xl text-[#D97757]">studio access</div>
        <h1 className="font-serif text-4xl mt-1">Admin sign in</h1>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <input
            data-testid="admin-email"
            required type="email" className="input-warm" placeholder="Email"
            value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
          />
          <input
            data-testid="admin-password"
            required type="password" className="input-warm" placeholder="Password"
            value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
          />
          <button data-testid="admin-login-btn" disabled={busy} className="btn-primary w-full disabled:opacity-60">
            {busy ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
